import { ORDER_STATUSES } from '@folio/stripes-acq-components';

export const PO_WORKFLOW_STATUSES = ORDER_STATUSES;
export const WORKFLOW_STATUS = ORDER_STATUSES;
